module.exports = {
	"apiKey": "ENTER API KEY HERE"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/googleMaps-example.credentials.json
// module id = 1410
// module chunks = 0